// slider
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/styles/main.scss';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './pages/home/Home';
import Header from './layout/Header';
import Footer from './layout/footer/Footer';
import AboutUs from './pages/about/AboutUs';
import Resources from './pages/resources/Resources';
import Services from './pages/services/Services';
import ContactUs from './pages/contact/ContactUs';

// Aos
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import ScrollToTop from './ScrollToTop';
import PrivacyPolicy from './pages/privacypolicy/PrivacyPolicy';
import TermsOfUse from './pages/termsofuse/TermsOfUse';
import Corporate from './pages/corporate/Corporate';
import Expertise from './pages/expertise/Expertise';
import Individuals from './pages/individuals/Individuals';
import Lawyer from './pages/lawyers/Lawyer';
function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000, // duration of animation
      easing: 'ease-out',
    });
  }, []);
  return (
    <BrowserRouter>
      <ScrollToTop />

      <ToastContainer />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/expertise" element={<Expertise />} />
        <Route path="/corporate" element={<Corporate />} />
        <Route path="/lawyers" element={<Lawyer />} />
        <Route path="/individuals" element={<Individuals />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<TermsOfUse />} />
        <Route path="/expertise" element={<Expertise />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
